import { storage } from './storage';

export const routes = {
  DEFAULT: '/',
  SIGN_OUT: '/sign-out',
  LOGIN: '/login',
  FORMULA_ACTIVITY: '/formula/activity',
  ADD_FORMULA: '/formula/add',
  EDIT_FORMULA: '/formula/edit',
  CHANGE_PASSWORD: '/change-password',
  CHANGE_PIN_CODE: '/change-pin-code',
  WAREHOUSE: '/warehouse',
  WAREHOUSE_DETAIL: '/warehouse/:id',
};

export interface RouteGuard {
  /**
   * If the condition is not met then either redirect to onFail or don't render the route
   */
  failCondition: boolean;
  /**
   * If request is still in progress we don't want to call onFail yet
   */
  requestDone: boolean;
  /**
   * URL where to redirect to, when condition is not met
   */
  onFail?: string | null;
}

export const unAuthGuard: RouteGuard = {
  failCondition: !!storage.getToken(),
  requestDone: true,
  onFail: routes.DEFAULT,
};

export const authGuard: RouteGuard = {
  failCondition: !storage.getToken(),
  requestDone: true,
  onFail: routes.LOGIN,
};
